import { shareURL } from '@telegram-apps/sdk-react';

/**
 * Utility API functions - clipboard, sharing, etc.
 */

/**
 * Get user's referral code (extracted from referral link)
 */
export const extractReferralCode = (referralLink: string): string => {
  try {
    // Extract telegram user ID from the referral link
    const regex = /start=(\w+)/;
    const match = regex.exec(referralLink);
    return match ? match[1] : 'UNKNOWN';
  } catch (error) {
    console.error('Error extracting referral code:', error);
    return 'UNKNOWN';
  }
};

/**
 * Copy text to clipboard
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    } else {
      // Fallback for older browsers or non-secure contexts
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      // eslint-disable-next-line deprecation/deprecation
      const successful = document.execCommand('copy');
      document.body.removeChild(textArea);

      return successful;
    }
  } catch (error) {
    console.error('Error copying to clipboard:', error);
    return false;
  }
};

/**
 * Share referral code using Telegram's share functionality
 */
export const shareReferralCode = (referralCode: string): void => {
  try {
    shareURL(
      'https://t.me/triggerdotfun_bot?start=' + referralCode,
      '🎯 Join me on Trigger Trading Bot!\n\nGet instant crypto trading alerts and trade directly from Telegram.'
    );
  } catch (error) {
    console.error('Error sharing referral code:', error);
    // Fallback to copying
    copyToClipboard(referralCode);
  }
};

/**
 * Share referral link using Telegram's share functionality (legacy)
 */
export const shareReferralLink = (referralLink: string): void => {
  try {
    const message = `🎯 Join me on Trigger Trading Bot!\n\nGet instant crypto trading alerts and trade directly from Telegram.\n\n${referralLink}`;

    // Check if we're in Telegram environment
    if (window.Telegram?.WebApp) {
      // Use Telegram's share functionality if available
      const shareUrl = `https://t.me/share/url?url=${encodeURIComponent(referralLink)}&text=${encodeURIComponent(message)}`;
      window.open(shareUrl, '_blank');
    } else {
      // Fallback to copying the link
      copyToClipboard(referralLink);
    }
  } catch (error) {
    console.error('Error sharing referral link:', error);
    // Fallback to copying
    copyToClipboard(referralLink);
  }
};

